<div class="block-full-width no-padding no-border-radius">
    <!--new password-->
    <div class="new-password">
        <div class="new-password-items-area">
            <h2 class="margin-bottom-10">
                {{ 'YOUR_NEW_PASSWORD' | translate }}
            </h2>
            <p class="required-text">{{ 'REQUIRED_FIELDS_FORM_TITLE' | translate }}</p>

            <form [formGroup]="passwordForm" (ngSubmit)="submit()" action="">
                <!--Adding the class .hidden-password will displayed the hidde option-->
                <div class="new-password-items-area__userpassword">
                    <ridango-form-field class="full-width relative mb-3 box-border" appearance="outline">
                        <input
                            class="!box-border"
                            (focus)="focusHandler()"
                            type="{{ showPassword ? 'text' : 'password' }}"
                            ridangoInput
                            matInput
                            formControlName="password"
                            required
                            ridangoUntouchOnFocusout />
                        <ridango-label>{{ 'PH_PASSWORD' | translate }}</ridango-label>
                        <div class="absolute right-0 top-0 mr-2 w-12" matSuffix>
                            <button
                                class="vl-app-light:primary pn-light:text-primary pn-app-light:text-primary flex-align-center flex w-12 justify-center p-0 text-secondary"
                                [attr.aria-label]="'HIDE_PASSWORD_ARIA_LABEL' | translate"
                                [attr.aria-pressed]="false"
                                (click)="togglePassword()"
                                matSuffix
                                type="button">
                                <mat-icon>{{ showPassword ? 'visibility' : 'visibility_off' }}</mat-icon>
                            </button>
                        </div>

                        <ridango-error
                            *ngIf="passwordForm.controls.password.touched"
                            [ngSwitch]="
                                getFirstError(passwordForm.controls.password, [
                                    'required',
                                    'minlength',
                                    'numberRequired'
                                ])
                            ">
                            <ng-container *ngSwitchCase="'required'">
                                {{ 'LOCAL_INPUT_VALIDATION_REQUIRED' | translate }}
                            </ng-container>
                            <ng-container *ngSwitchCase="'minlength'">
                                {{ 'LOCAL_INPUT_VALIDATION_MIN_LENGTH' | translate }}
                            </ng-container>
                            <ng-container *ngSwitchCase="'numberRequired'">
                                {{ 'LOCAL_INPUT_PASSWORD_MISSING_NUMBER_LENGTH' | translate }}
                            </ng-container>
                        </ridango-error>
                    </ridango-form-field>

                    <ridango-form-field class="full-width relative mb-5 box-border">
                        <input
                            class="!box-border"
                            (focus)="focusHandler()"
                            type="{{ showPasswordRepeat ? 'text' : 'password' }}"
                            ridangoInput
                            matInput
                            formControlName="passwordRepeat"
                            required
                            ridangoUntouchOnFocusout />
                        <ridango-label>{{ 'PH_REPEAT_PASSWORD' | translate }}</ridango-label>
                        <div class="absolute right-0 top-0 mr-2" matSuffix>
                            <button
                                class="vl-app-light:primary pn-light:text-primary pn-app-light:text-primary flex-align-center flex w-12 justify-center p-0 text-secondary"
                                [attr.aria-label]="'HIDE_PASSWORD_REPEAT_ARIA_LABEL' | translate"
                                [attr.aria-pressed]="false"
                                (click)="togglePasswordRepeat()"
                                matSuffix
                                type="button">
                                <mat-icon>{{ showPasswordRepeat ? 'visibility' : 'visibility_off' }}</mat-icon>
                            </button>
                        </div>

                        <ridango-error
                            *ngIf="passwordForm.controls.passwordRepeat.touched"
                            [ngSwitch]="
                                getFirstError(passwordForm.controls.passwordRepeat, [
                                    'required',
                                    'minlength',
                                    'numberRequired'
                                ])
                            ">
                            <ng-container *ngSwitchCase="'required'">
                                {{ 'LOCAL_INPUT_VALIDATION_REQUIRED' | translate }}
                            </ng-container>
                            <ng-container *ngSwitchCase="'minlength'">
                                {{ 'LOCAL_INPUT_VALIDATION_MIN_LENGTH' | translate }}
                            </ng-container>
                            <ng-container *ngSwitchCase="'numberRequired'">
                                {{ 'LOCAL_INPUT_PASSWORD_MISSING_NUMBER_LENGTH' | translate }}
                            </ng-container>
                        </ridango-error>
                    </ridango-form-field>
                </div>

                <button class="btn btn--maximal btn--primary btn--big" [disabled]="loading$ | async">
                    {{ 'SAVE_PASSWORD' | translate }}
                </button>
            </form>
        </div>
    </div>
</div>
